import { CSSResultGroup, html, LitElement, TemplateResult } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'

import { paymentMethodList } from './payment-methods.style.js'
import { CSCPaymentMethod } from './methods/payment-method.js'
import { GET_PAYMENT_METHODS_BACKEND, GetPaymentMethodsBackend } from './payment-backend/get-payment-methods-backend.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'


@customElement('csc-payment-methods')
export class CSCPaymentMethods extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, paymentMethodList]

  @property({ attribute: 'get-payment-methods-path' })
  getPaymentMethodsPath: string = ''

  @property({ type: Object, attribute: 'payment-methods-payload' })
  paymentMethodsPayload?: object

  @inject(GET_PAYMENT_METHODS_BACKEND)
  private getPaymentMethodsBackend!: GetPaymentMethodsBackend

  @state()
  private paymentMethods: CSCPaymentMethod[] = []

  override async connectedCallback() {
    super.connectedCallback()

    const hasPayload = !!this.paymentMethodsPayload && Object.keys(this.paymentMethodsPayload).length > 0

    this.paymentMethods = await this.getPaymentMethodsBackend.getPaymentMethods(
      hasPayload ? this.paymentMethodsPayload : this.getPaymentMethodsPath,
    )
  }

  protected override render(): TemplateResult {
    return html`
      <div class="payment-method-list">
        ${this.paymentMethods}
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-payment-methods': CSCPaymentMethods,
  }
}
